import { Icon } from '@storeblocks/icon';
import InlineAlert from '@storeblocks/inline-alert/lib';
import React, { ReactElement } from 'react';
import {
  InsuranceInfoCardActionBar,
  InsuranceInfoCardContainer,
  InsuranceInfoCardContent,
  InsuranceInfoCardFooter,
  InsuranceInfoCardSurface,
  InsuranceInfoCardWrapper,
} from './insuranceInfoCard.styled';

interface InsuranceInfoCardProps extends React.PropsWithChildren {
  icon?: string;
  title: string;
  description?: string | React.ReactNode;
  actionBarTop?: React.ReactNode;
  actionBarBottom?: React.ReactNode;
  error?: string;
  maxWidth?: string;
}

export const InsuranceInfoCard = ({
  icon,
  title,
  description,
  actionBarTop,
  actionBarBottom,
  error,
  children,
  maxWidth,
}: InsuranceInfoCardProps): ReactElement => {
  const isCardWithIcon = icon !== undefined;
  const isDescriptionValidReactElement = React.isValidElement(description);

  return (
    <InsuranceInfoCardSurface maxWidth={maxWidth}>
      <InsuranceInfoCardWrapper>
        <InsuranceInfoCardContainer hasIcon={isCardWithIcon}>
          {isCardWithIcon && <Icon name={icon} size={47} mr="18px" />}
          <InsuranceInfoCardContent>
            <h4>{title}</h4>
            {isDescriptionValidReactElement ? (
              <div>{description}</div>
            ) : (
              <p>{description}</p>
            )}
            {error && <InlineAlert title={error} variant="error" />}
          </InsuranceInfoCardContent>
        </InsuranceInfoCardContainer>
        <InsuranceInfoCardActionBar>{actionBarTop}</InsuranceInfoCardActionBar>
      </InsuranceInfoCardWrapper>
      {actionBarBottom && (
        <InsuranceInfoCardFooter>{actionBarBottom}</InsuranceInfoCardFooter>
      )}
      {children}
    </InsuranceInfoCardSurface>
  );
};
